import {
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
  Renderer2,
  Inject,
  PLATFORM_ID
} from '@angular/core';
import { Router } from '@angular/router';
import { isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'app-welcome',
  templateUrl: './welcome.component.html',
  styleUrl: './welcome.component.scss'
})
export class WelcomeComponent implements OnInit, OnDestroy {

  @Output() close = new EventEmitter<boolean>();

  showPopup: boolean = false;
  welcome: boolean = false;

  currentLanguage!: string | null;

  lang = [
    { code: 'en', name: 'English' },
    { code: 'ar', name: 'Arabic' },
  ];

  private isBrowser: boolean;

  constructor(
    private _router: Router,
    private render: Renderer2,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  // ================= INIT =================
  ngOnInit(): void {
    if (this.isBrowser) {
      this.welcome = localStorage.getItem('welcome') === 'true';
      localStorage.setItem('welcome', 'true');
    }
  }

  // ================= DESTROY =================
  ngOnDestroy(): void {
    // مفيش listeners أو intervals هنا
  }

  // ================= UI ACTIONS =================
  openPopup(): void {
    this.showPopup = true;
  }

  createAccount(): void {
    this.welcome = true;
    this._router.navigate(['/Resigter']);
  }

  skipToHome(): void {
    this.welcome = true;
    this._router.navigate(['/Home']);
  }

}
